





























































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { onlyFloat, timeout, truncateText, validateLength, capitalizeCase, isNull } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import { Procedimento, GrupoOpme, GrupoOpmes } from '@/types/_'
import _ from 'lodash'
import { SolicitacaoGrupoOpme } from '@/types/interfaces/Solicitacao'
import { SolicitacaoOpme } from '@/types/interfaces/protocolo/protocolo.interface'

@Component
export default class ComponentModalBackofficeOPME extends Vue {
  @Prop({ required: true, default: {} }) procedimentoPrincipal: Procedimento
  @Prop({ required: false, default: [] }) procedimentoAssociado: Procedimento[]

  $refs!: {
    formNovoFornecedor: any,
    formGrupoOpme: any,
    cardGrupoOpme: any,
    formNovoOPME: any,
    fornecedor1: any,
    fornecedor2: any,
    fornecedor3: any,
  }

  cadastroOPME: boolean = false
  cadastroFornecedores: boolean = false
  grupoOpme = {} as GrupoOpme
  mdEditOPME: boolean = false
  loadClose: boolean = false
  isEdit: boolean = false
  loadAdicionarOPME: boolean = false
  loadEditClose: boolean = false
  loadSaveOPME: boolean = false
  loadSaveFornecedor: boolean = false
  loadConfirmar: boolean = false
  boxNovoFornecedor: boolean = false
  descricao: string = ''
  fornecedor: string = ''
  numCampos: number = 1
  nvOPME: boolean = false
  busca: string = ''
  fornecedoresRulesTemplate: any = {
    fornecedor1Id: true,
    fornecedor2Id: false,
    fornecedor3Id: false,
  }

  currentOpmeJson = ''

  get getFornecedoresRules() {
    return this.fornecedoresRulesTemplate
  }

  set getFornecedoresRules(rules: any) {
    this.fornecedoresRulesTemplate = rules
  }

  fornecedorAtivo(fornecedor) {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.campos && this.getTemplate.opmes.campos[fornecedor]
  }

  validateFornecedor(value, templateField) {
    const { opmes } = this.getTemplate

    if (opmes.campos[templateField] && opmes[templateField].obrigatorio && ['', null, undefined].includes(value)) {
      return 'Campo obrigatório.'
    }

    if (opmes.campos[templateField] && !opmes[templateField].permiteNaoInformado && value === this.NAO_INFORMADO) {
      return 'Por favor, informe um fornecedor válido.'
    }

    return true
  }

  fornecedoresRules: any = {
    valid: true,
    fornecedor1Id: [v => this.validateFornecedor(v, 'fornecedor1Id')],
    fornecedor2Id: [v => this.validateFornecedor(v, 'fornecedor2Id')],
    fornecedor3Id: [v => this.validateFornecedor(v, 'fornecedor3Id')],
    opme: [v => (!!v && !!v.id) || 'Campo obrigatório.'],
    quantidade: [v => (!!v && parseFloat(v) > 0) || 'Campo obrigatório.'],
  }

  /**
   * ------------------------------------------------------------------------------------------
   * NOVA VALIDAÇÃO DE FORNECEDORES
   * __________________________________________________________________________________________
   */
  // Id do fornecedor 'Não Informado'
  NAO_INFORMADO = '50a949cc-7c46-4f86-a160-90b95371b542'

  possuiOMesmoFornecedor(id1: string | undefined, id2: string | undefined, id3: string | undefined) {
    if (!isNull(id1) && !isNull(id2) && !isNull(id3)) return id1 === id2 || id1 === id3 || id2 === id3
    if (!isNull(id1) && !isNull(id2) && isNull(id3)) return id1 === id2
    if (!isNull(id1) && isNull(id2) && !isNull(id3)) return id1 === id3
    if (isNull(id1) && !isNull(id2) && !isNull(id3)) return id2 === id3
    return false
  }

  validarDuplicatas() {
    const isFormValid: boolean[] = []
    for (let i = 0; i < this.$refs.formGrupoOpme.length; i++) {
      const fornecedor1 = this.fornecedorAtivo('fornecedor1Id') ? this.$refs.fornecedor1[i].value : ''
      const fornecedor2 = this.fornecedorAtivo('fornecedor2Id') ? this.$refs.fornecedor2[i].value : ''
      const fornecedor3 = this.fornecedorAtivo('fornecedor3Id') ? this.$refs.fornecedor3[i].value : ''
      isFormValid.push(this.possuiOMesmoFornecedor(fornecedor1, fornecedor2, fornecedor3))
    }

    isFormValid.forEach((form: boolean, index: number) => {
      if (form) this.pointError(index)
    })

    return isFormValid.some((e: boolean) => e === true)
  }

  validarFornecedores() {
    const isFormValid: boolean[] = []
    for (let i = 0; i < this.$refs.formGrupoOpme.length; i++) {
      isFormValid.push(this.$refs.formGrupoOpme[i].validate())
    }

    isFormValid.forEach((form: boolean, index: number) => {
      if (!form) this.pointError(index)
    })

    return isFormValid.some((e: boolean) => e === false)
  }

  async pointError(index: number) {
    this.$refs.cardGrupoOpme[index].$el.style.background = 'rgba(255,0,0,.05)'
    await timeout(8500)
    this.$refs.cardGrupoOpme[index].$el.style.background = 'transparent'
  }

  resetValidacaoFornecedores() {
    for (let i = 0; i < this.$refs.formGrupoOpme.length; i++) {
      this.$refs.formGrupoOpme[i].resetValidation()
      this.$refs.formGrupoOpme[i].reset()
    }
  }

  novoFornecedorRules: any = {
    valid: true,
    fornecedorRules: [
      v => !!v || `O campo ${this.fornecedorLabel} é obrigatório.`,
      v => validateLength(v, 3) || `O campo ${this.fornecedorLabel} deve ter pelo menos 3 caracteres.`,
    ],
  }

  novoOPMERules: any = {
    valid: true,
    descricaoRules: [v => !!v || 'Campo obrigatório.'],
  }

  capitalizeCaseUtil(value: string) {
    return capitalizeCase(value)
  }

  clearObservacao(opme: any) {
    // if (!opme.possuiGrade) {
    //   opme.observacao = ''
    // }
  }

  setFornecedoresRules() {
    // validação antiga estava sendo pegada do template, porém o fornecedor 1 sempre obrigatório
    const { formulario } = this.getBackofficeGlobalStore.template
    const fornecedores = formulario && formulario.opmes && formulario.opmes.campos
      ? { ...formulario.opmes.campos, fornecedor1Id: true }
      : this.fornecedoresRulesTemplate
    this.getFornecedoresRules = fornecedores
  }

  @Watch('showModalOPME')
  async onChangeShowModalOPME(value) {
    await setTimeout(() => {
      const input = document.querySelector('.opme-input input') as HTMLInputElement
      if (value) {
        input.focus()
      } else {
        input.blur()
      }
    }, 100)
    value && this.setFornecedoresRules()
  }

  @Watch('showModalCadastroFornecedores')
  async onChangeShowModalCadastroFornecedores(value: boolean) {
    if (!value) {
      this.$nextTick(async () => {
        this.$refs.formNovoFornecedor.resetValidation()
        this.$refs.formNovoFornecedor.reset()
        this.getBackofficeGlobalStore.clearNovoFornecedor()
      })
    }
  }

  @Watch('showModalCadastroOPME')
  async onChangeShowModalCadastroOPME(value: boolean) {
    if (!value) {
      this.$nextTick(async () => {
        this.$refs.formNovoOPME.resetValidation()
        this.$refs.formNovoOPME.reset()
        this.getBackofficeGlobalStore.clearNovoOPME()
      })
    }
  }

  adicionarItemOPME() {
    const opme = this.getBackofficeGlobalStore.opmeDefault
    const json = JSON.stringify(opme)
    const clone: GrupoOpmes = JSON.parse(json)
    this.validarFormAdicionarItem() && this.grupoOpme.opmes.push(clone)
  }

  async removeItemOPME(index: number) {
    if (this.grupoOpme.opmes.length > 1) {
      this.grupoOpme.opmes.splice(index, 1)
    }
  }

  get getTemplate() {
    return this.getBackofficeGlobalStore.template.formulario
  }

  get fornecedorLabel() {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.fornecedorLabel
      ? this.getTemplate.opmes.fornecedorLabel
      : 'fornecedor / marca'
  }

  get fornecedorButtonLabel() {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.fornecedorButtonLabel
      ? this.getTemplate.opmes.fornecedorButtonLabel
      : 'Cadastrar fornecedor'
  }

  get showModalCadastroOPME() { return this.getBackofficeGlobalStore.modal.cadastrarMaterial }
  set showModalCadastroOPME(value: boolean) {
    this.getBackofficeGlobalStore.setShowModalCadastrarMaterial(value)
  }

  get showModalCadastroFornecedores() { return this.getBackofficeGlobalStore.modal.cadastrarFornecedor }
  set showModalCadastroFornecedores(value: boolean) {
    this.getBackofficeGlobalStore.setShowModalCadastrarFornecedor(value)
  }

  get loadingConfirmar() { return this.loadConfirmar }
  set loadingConfirmar(value: boolean) { this.loadConfirmar = value }

  get loadingAdicionarOPME() { return this.loadAdicionarOPME }
  set loadingAdicionarOPME(value: boolean) { this.loadAdicionarOPME = value }

  get loadingSaveOPME() { return this.loadSaveOPME }
  set loadingSaveOPME(value: boolean) { this.loadSaveOPME = value }

  get loadingSaveFornecedor() { return this.loadSaveFornecedor }
  set loadingSaveFornecedor(value: boolean) { this.loadSaveFornecedor = value }

  get novoFornecedor() {
    return this.getBackofficeGlobalStore.novoFornecedor
  }

  get getOpmes() { return this.getBackofficeGlobalStore.solicitacaoAlterada.grupoOpme }
  set getOpmes(value: any[]) { this.getBackofficeGlobalStore.setGrupoOpmes(value) }

  truncateTitle(str: string) {
    return truncateText(str, 16)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get OPMEs() {
    const { medicoGrupoOpmes } = this.getBackofficeGlobalStore
    return medicoGrupoOpmes.filter((e: any) => e.descricao.toLowerCase().includes(this.busca.toLowerCase()))
  }

  get fornecedores() {
    return this.getBackofficeGlobalStore.fornecedores
  }

  get numeroDeCampos() { return this.numCampos }
  set numeroDeCampos(value: number) { this.numCampos = value }

  get showModalOPME() { return this.getBackofficeGlobalStore.modal.editarOpme }
  set showModalOPME(value: boolean) { this.getBackofficeGlobalStore.setModal({ name: 'editarOpme', value }) }

  get loadingClose() { return this.loadClose }
  set loadingClose(value: boolean) { this.loadClose = value }

  get showModalEditOPME() { return this.mdEditOPME }
  set showModalEditOPME(value: boolean) { this.mdEditOPME = value }

  get loadingEditClose() { return this.loadEditClose }
  set loadingEditClose(value: boolean) { this.loadEditClose = value }

  get novoOPME() { return this.nvOPME }
  set novoOPME(value: boolean) { this.nvOPME = value }

  async confirmar() {
    this.loadingConfirmar = true
    let canCreateNewOpme = true
    const json = JSON.stringify(this.grupoOpme)

    const grupoOpme: GrupoOpme = JSON.parse(json)

    if (this.validarDuplicatas()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Um OPME não pode ter fornecedor(es) duplicado(s)!', icon: 'warning', color: '#C62828', timeout: 5500 })
      this.loadingConfirmar = false
      return
    }

    if (this.validarFornecedores()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Verifique o(s) erro(s) abaixo.', icon: 'warning', color: '#C62828', timeout: 5500 })
      this.loadingConfirmar = false
      return
    }

    const isFormValid = this.validarFormAdicionarItem()

    if (isFormValid) {
      // Verifica se é uma edição. Caso seja, verifica se não houve alterações no opme e se ele já existe na listagem.
      // Caso ele já exista na listagem e não houve nenhuma edição, não faz nada, apenas retorna
      if (this.isEdit === true) {
        if (json === this.currentOpmeJson) {
          canCreateNewOpme = false
        }
        if (canCreateNewOpme === false && this.checkExistsGrupoOpmeInSolicitacaoAlterada(grupoOpme)) {
          this.closeModalEditOPME()
          this.closeModalOPME()
          this.loadingConfirmar = false
          return
        }
      }

      // preenche o opmeId
      grupoOpme.opmes.forEach((elem: any) => {
        // eslint-disable-next-line
        elem.opmeId = elem.opme.id

        Object.entries(elem).forEach(([key, value]) => {
          // @ts-ignore
          if (['', null, 0, undefined].includes(value)) {
            // eslint-disable-next-line
            delete elem[key]
          }
        })
      })

      // eslint-disable-next-line
      const grupoOpmeDaSolicitacao = this.getBackofficeGlobalStore.solicitacaoAlterada.grupoOpmeDaSolicitacao
      const { hospitalId, medicoSolicitanteId, procedimento } = this.getBackofficeGlobalStore.solicitacaoAlterada
      const gruposOpmesNew = {
        descricao: procedimento.descricao,
        id: grupoOpme.id,
        opmes: grupoOpme.opmes,
        hospitalId,
        medicoId: medicoSolicitanteId,
        procedimentoId: procedimento.id,
        procedimentoCodigo: grupoOpme.procedimentoCodigo,
        tipo: grupoOpme.tipo,
      } as GrupoOpme

      Object.entries(gruposOpmesNew).forEach(([key, value]) => {
        // @ts-ignore
        if (['', null, 0, undefined].includes(value)) {
          delete gruposOpmesNew[key]
        }
      })

      if (canCreateNewOpme) {
        const response = await this.getBackofficeGlobalStore.createMedicoGrupoOpme(gruposOpmesNew)
        if (response.success) {
          gruposOpmesNew.id = response.data
        }
      }

      grupoOpmeDaSolicitacao.push(gruposOpmesNew)

      await timeout(500)

      this.closeModalEditOPME()
      this.closeModalOPME()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: `Existem campos não preenchidos nesta lista ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingConfirmar = false
  }

  checkExistsGrupoOpmeInSolicitacaoAlterada(grupoOpmeToCreate: GrupoOpme) {
    const grupoOpmesToCreateArray = grupoOpmeToCreate.opmes
    // eslint-disable-next-line
    const grupoOpmesToCreateMapped = grupoOpmesToCreateArray.map(elem => {
      const { opme, quantidade, fornecedor1Id, fornecedor2Id, fornecedor3Id } = elem
      return { opmeId: opme.id, quantidade, fornecedor1Id, fornecedor2Id, fornecedor3Id }
    })
      .sort((a, b) => a.quantidade - b.quantidade)
    const grupoOpmesToCreateJson = JSON.stringify(grupoOpmesToCreateMapped)

    // eslint-disable-next-line
    const notExists = this.getBackofficeGlobalStore.solicitacaoAlterada.grupoOpmeDaSolicitacao.every((elem: GrupoOpme) => {
      // eslint-disable-next-line
      const grupoOpmesToCheckMapped = elem.opmes.map(elem => {
        const { opme, quantidade, fornecedor1Id, fornecedor2Id, fornecedor3Id } = elem
        return { opmeId: opme.id, quantidade, fornecedor1Id, fornecedor2Id, fornecedor3Id }
      })
        .sort((a, b) => a.quantidade - b.quantidade)
      const grupoOpmesToCheckJson = JSON.stringify(grupoOpmesToCheckMapped)

      if (grupoOpmesToCreateJson === grupoOpmesToCheckJson) {
        return false
      }

      return true
    })

    return !notExists
  }

  setCarater(carater: string) {
    switch (carater) {
      case 'EletivoSemAutorizacao':
        return { key: 'EletivoSemAutorizacao', display: 'Emergência' }
      case 'Emergencia':
        return { key: 'Emergencia', display: 'Emergência' }
      case 'Urgencia':
        return { key: 'Urgencia', display: 'Urgência' }
      default:
        return { key: 'EletivoAutorizacao', display: 'Eletivo' }
    }
  }

  closeModalOPME() {
    this.showModalOPME = false
    this.getBackofficeGlobalStore.clearOpmeGrupoId()
    this.getBackofficeGlobalStore.clearListaMedicoOpme()
    this.busca = ''
  }

  closeModalEditOPME() {
    this.showModalEditOPME = false
    this.resetGrupoOpme()
    this.clearFormValidation()
    this.currentOpmeJson = ''
    this.getBackofficeGlobalStore.clearOpmeGrupoId()
    this.getBackofficeGlobalStore.resetOPMEGrupo()
    this.getBackofficeGlobalStore.clearOpmeGrupoInicial()
    this.getBackofficeGlobalStore.clearFornecedores()
    this.getBackofficeGlobalStore.clearNovoFornecedor()
    this.getBackofficeGlobalStore.clearNovoOPME()
    this.$refs.formNovoFornecedor.reset()
    this.$refs.formNovoFornecedor.resetValidation()
    this.$refs.formNovoOPME.reset()
    this.$refs.formNovoOPME.resetValidation()
  }

  resetGrupoOpme() {
    const opme = this.getBackofficeGlobalStore.grupoOpmeDefault
    const json = JSON.stringify(opme)
    const clone: GrupoOpme = JSON.parse(json)
    this.grupoOpme = clone
  }

  async adicionarOPME() {
    this.loadingAdicionarOPME = true
    this.isEdit = false
    this.resetGrupoOpme()
    await this.getBackofficeGlobalStore.loadFornecedores()
    await this.getBackofficeGlobalStore.getMedicoOpme()
    this.showModalEditOPME = true
    this.loadingAdicionarOPME = false
  }

  async editOPME(opme: GrupoOpme) {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    this.isEdit = true
    await this.getBackofficeGlobalStore.loadFornecedores()
    await this.getBackofficeGlobalStore.getMedicoOpme()
    const json = JSON.stringify(opme)
    this.currentOpmeJson = json
    const clone: GrupoOpme = JSON.parse(json)
    this.grupoOpme = clone

    EventBus.$emit('clearLoadingRequest')
    this.showModalEditOPME = true
  }

  useKit(opme: GrupoOpme) {
    const clonedGrupoOpme: GrupoOpme = JSON.parse(JSON.stringify(opme))

    const opmes: SolicitacaoOpme[] = clonedGrupoOpme.opmes.map((elem) => {
      const { id, descricao } = elem.opme
      const {
        quantidade, gradeCompleta, observacao, fornecedor1Id, fornecedor2Id, fornecedor3Id, medicoPodeAlterarAQuantidade,
      } = elem as any

      return {
        id, descricao, quantidade, gradeCompleta, observacao, fornecedor1Id, fornecedor2Id, fornecedor3Id, medicoPodeAlterarAQuantidade,
      }
    })

    const grupoDeOpme: SolicitacaoGrupoOpme = {
      id: clonedGrupoOpme.id,
      descricao: clonedGrupoOpme.descricao,
      opmes,
    }

    // Clear all opmes
    this.getBackofficeGlobalStore.solicitacaoAlterada.grupoDeOpme!.opmes.splice(
      0, this.getBackofficeGlobalStore.solicitacaoAlterada.grupoDeOpme!.opmes.length,
    )

    grupoDeOpme.opmes.forEach((elem) => {
      this.getBackofficeGlobalStore.solicitacaoAlterada.grupoDeOpme!.opmes.push(elem)
    })

    this.$emit('change')

    this.closeModalOPME()
  }

  onlyFloatUtil(value) {
    return onlyFloat(value)
  }

  adicionarItem() {
    const isFormValid = this.validarFormAdicionarItem()

    if (isFormValid) {
      this.getBackofficeGlobalStore.adicionarOpmeDefault()
    }
  }

  validarFormAdicionarItem() {
    let isFormValid: boolean = true
    for (let i = 0; i < this.grupoOpme.opmes.length; i++) {
      if (!this.$refs.formGrupoOpme[i].validate()) {
        isFormValid = false
      }
    }
    return isFormValid
  }

  clearFormValidation() {
    for (let i = 0; i < this.grupoOpme.opmes.length; i++) {
      this.$refs.formGrupoOpme[i].resetValidation()
      this.$refs.formGrupoOpme[i].reset()
    }
  }

  cadastrarOPME() {
    this.novoOPME = !this.novoOPME
  }

  async saveOPME() {
    this.loadingSaveOPME = true
    if (this.$refs.formNovoOPME.validate()) {
      const response = await this.getBackofficeGlobalStore.createNovoOPME()

      if (response) {
        // Nesse ponto é necessário fazer a listagem dos OPMEs mais uma vez, antes de limpar o novoOPME...
        this.showModalCadastroOPME = false
        EventBus.$emit('setSnackbar', { show: true, text: `Material adicionado com sucesso. Agora você pode selecioná-lo na lista de materiais. ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32', timeout: 4500 })
        this.getBackofficeGlobalStore.clearNovoOPME()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: `Ocorreu um problema com essa requisição ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
        this.getBackofficeGlobalStore.clearNovoOPME()
      }
    }

    this.loadingSaveOPME = false
    // this.novoOPME = false
  }

  async salvarNovoFornecedor() {
    this.loadingSaveFornecedor = true
    if (this.$refs.formNovoFornecedor.validate()) {
      const response = await this.getBackofficeGlobalStore.postFornecedor()
      if (response.success) {
        this.showModalCadastroFornecedores = false
        EventBus.$emit('setSnackbar', { show: true, text: `${this.fornecedorLabel} adicionado com sucesso. Agora você pode selecioná-lo na lista de fornecedores. ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32', timeout: 4500 })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || `Ocorreu um problema com essa requisição ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingSaveFornecedor = false
  }

  deleteOpme(index) {
    this.getBackofficeGlobalStore.deleteOpmes(index)
    this.getBackofficeGlobalStore.opmeDisabledChangeOnDelete()
  }

  @Watch('novoOPME')
  onChangeNovoOPME(value) {
    if (!value) {
      this.getBackofficeGlobalStore.clearNovoOPME()
      this.$nextTick(() => {
        if (this.$refs.formNovoOPME) this.$refs.formNovoOPME.reset()
      })
    }
  }

  opmeDisabledChange() {
    this.getBackofficeGlobalStore.listaMedicoOpme.map((e: any) => {
      const opme = e
      opme.disabled = this.grupoOpme.opmes.some(op => op.opmeId === e.id)
      return opme
    })
  }
}
